import { Alert, Button, Col, Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink, Row, Label, FormFeedback, Form, Input, FormGroup, Spinner, InputGroup } from 'reactstrap'
import Select from 'react-select'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { selectThemeColors } from '../../../utility/Utils'
import { Check, Trash } from 'react-feather'
import { selectProfile, sendAdharOTP, setAddharLoader, setAdharStatus, setLoader, setMessage, setPanLoader, setPanStatus, setRequestId, updateKYCDeatils, validateAdharOTP, verifyPan } from './store'
import React, { useEffect, useState } from 'react'
import { handleDecimal } from '../../components/modal/modalSubComponet'

const KYCDeatils = ({ toggle }) => {

    const { myProfile, kycStatus, loader, message, AdharStatus, PanStatus, requestId, addharLoader } = useSelector((store) => store?.MyProfile)
    const dispatch = useDispatch()
    const {
        reset,
        control,
        setError,
        setValue,
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({})
    
    console.log("🚀 ~ file: KYCDeatils.js:26 ~ KYCDeatils ~ myProfile:", myProfile)
    const [handleKyc, setHandleKyc] = useState({
        aadhaar_number: myProfile?.aadhaar_number ? myProfile?.aadhaar_number : '',
        requestId: "",
        aadharOtp: "",
        aadhar: false,
        aadharOtpBtn: false,
        pan_number: myProfile?.pan_number ? myProfile?.pan_number : '',
        pancard: false,
    });
    const [myType, setMyType] = useState("");
    const [errorAddhar, setErrorAddhar] = useState("");
    const [errorPancard, setErrorPancard] = useState("");
    const [seconds, setSeconds] = useState(60);
    const [isActive, setIsActive] = useState(false);
    const [OTPInput, setOTPInput] = useState({
        aadharOtpInput: false,
        PanOtpInput: false
    });
    const [enterOtp, setEnterOtp] = useState(false);
    const [startCounter, setStartCounter] = useState(false)

    const handleDiscard = () => {
        setOTPInput({
            aadharOtpInput: false,
            PanOtpInput: false
        })
        dispatch(setLoader(false));
        dispatch(selectProfile(null))
        dispatch(setMessage(null))
        reset()
        toggle()
    }

    const handleInputChange = (value, name) => {
        setHandleKyc((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        if (name === 'aadharOtp' && value.length === 6) {
            setHandleKyc((prevData) => ({
                ...prevData,
                aadharOtpBtn: true,
            }));
        } else {
            setHandleKyc((prevData) => ({
                ...prevData,
                aadharOtpBtn: false,
            }));
        }
    };

    const reSend = () => {
        setSeconds(60)
        SendOTP(handleKyc.aadhaar_number)
    }

    const SendOTP = async (aadhaar_number) => {
        dispatch(setAddharLoader(true));
        await dispatch(sendAdharOTP({ aadhaar_number }))
    }

    useEffect(() => {
        dispatch(setLoader(false));
        dispatch(setPanStatus(""));
        dispatch(setAdharStatus(""));
    }, [])

    const submit = async () => {


        let formData = new FormData()
        formData.append('aadhaar_number', handleKyc.aadhaar_number)
        formData.append('pan_number', handleKyc.pan_number)

        dispatch(setLoader(true))

        await dispatch(updateKYCDeatils(formData))

        kycStatus === 200 && handleDiscard()
    }

    console.log('kycStatus', kycStatus)
    useEffect(() => {
        if (message) {
            setIsActive(true)
            setOTPInput({
                aadharOtpInput: true,
                PanOtpInput: false
            })
        }
        if (seconds === 0) {
            dispatch(setMessage(""))
            setIsActive(false);
            // setStartCounter(true)
        }
    }, [seconds, message])

    useEffect(() => {
        let interval;

        if (isActive) {
            setStartCounter(false)
            interval = setInterval(() => {
                setSeconds(prevSeconds => prevSeconds - 1);
            }, 1000);
        } else {
            clearInterval(interval);
        }

        if (seconds === 0) {
            setIsActive(false);
        }

        return () => clearInterval(interval);
    }, [isActive, seconds]);


    useEffect(() => {
        setHandleKyc({ ...handleKyc, requestId })
    }, [requestId])

    return (
        <Row className='mb-2'>
            <Col md="6" xm="6">
                <label htmlFor="aadhaar_number">Aadhaar Number</label>
                <InputGroup>
                    <input
                        placeholder="Enter Aadhaar Number"
                        id="aadhaar_number"
                        name="aadhaar_number"
                        disabled={(handleKyc?.aadhar && OTPInput?.aadharOtpInput || AdharStatus === 200)}
                        className={`w-bolder text-black form-control ${errorAddhar ? 'is-invalid' : ''}`}
                        value={handleKyc?.aadhaar_number}
                        onChange={(e) => {
                            const { value } = e.target;
                            handleInputChange(value, 'aadhaar_number')
                            let regex = new RegExp(/^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/);
                            if (!regex.test(e.target.value)) {
                                setErrorAddhar('Please Enter Valid Aadhaar Number');
                            } else {
                                setErrorAddhar('');
                                if (regex.test(e.target.value)) {
                                    setHandleKyc({
                                        ...handleKyc,
                                        aadhaar_number: e.target.value,
                                        aadhar: true,
                                    })
                                    // setStartCounter(true)
                                    // SendOTP(e.target.value)
                                }
                            }
                        }}
                        onKeyPress={(e) => handleDecimal(e, 'number')}
                    />
                    {AdharStatus === 200 ? <small className='otpBtn'> <Check /></small> : <></>}
                </InputGroup>

                {
                    (handleKyc?.aadhar && !OTPInput?.aadharOtpInput) && <small className='pointer' onClick={() => {
                        setMyType('aadhaar_number')
                        SendOTP(handleKyc.aadhaar_number)
                    }}> {addharLoader && myType === 'aadhaar_number' ? 'Loading...' : 'Send OTP'} </small>
                }
                {
                    errorAddhar && <small className='text-danger text-center text-capitalize'> {errorAddhar} </small>
                }
            </Col>
            {/* <Col sm={6} className="mb-1">
          <Label className="form-label" for="aadhaar_image">
            Upload Aadhaar Card
          </Label>
          <Controller
            id="aadhaar_image"
            name="aadhaar_image"
            control={control}
            // {...register('aadhaar_image', {
            //     required: 'Please Upload Aadhaar Card'
            //   })}
            render={({ field }) => (
              <Input
                id="aadhaar_image"
                type="file"
                name="aadhaar_image"
                invalid={errors.aadhaar_image && true}
                onChange={handleFile}
                files={file}
              />
            )}
          />
        </Col> */}

            {OTPInput?.aadharOtpInput && AdharStatus !== 200 && <>

                <Col md="6" xm="6" >
                    <label htmlFor="aadharOtp">OTP</label>
                    <InputGroup>
                        <input
                            placeholder="Enter otp"
                            id="aadharOtp"
                            name="aadharOtp"
                            className={`w-bolder text-black form-control`}
                            value={handleKyc?.aadharOtp}
                            onChange={(e) => {
                                const { value } = e.target;
                                handleInputChange(value, 'aadharOtp')
                            }}
                            onKeyPress={(e) => handleDecimal(e, 'number')}
                        />
                        {
                            handleKyc?.aadharOtpBtn && <small className='pointer otpBtn' onClick={() => {
                                dispatch(setAddharLoader(true))
                                setMyType('aadharOtp')
                                dispatch(validateAdharOTP({
                                    aadhaar_number: handleKyc?.aadhaar_number,
                                    requestId: handleKyc?.requestId,
                                    otp: handleKyc?.aadharOtp
                                }))

                            }}>
                                {addharLoader && myType === 'aadharOtp' ? <Spinner text="Loading..." color="primary" size="sm" /> : 'Send'}
                            </small>
                        }
                    </InputGroup>
                    {(message && isActive) ? <small>Resend OTP in 00:{seconds < 10 ? `0${seconds}` : seconds}</small> : <small className='pointer' onClick={reSend}> Resend OTP </small>}


                </Col>
            </>
            }

            <Col md="6" xm="6">
                <label htmlFor="pan_number">Pancard Number</label>
                <InputGroup>
                    <input
                        placeholder="Enter Pancard Number"
                        id="pan_number"
                        name="pan_number"
                        disabled={PanStatus === 200 ? true : false}
                        className={`w-bolder text-black form-control ${errorPancard ? 'is-invalid' : ''}`}
                        value={handleKyc?.pan_number}
                        onChange={(e) => {
                            const { value } = e.target;
                            handleInputChange(value, 'pan_number')
                            let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]$/);
                            if (!regex.test(e.target.value)) {
                                setErrorPancard('Please Enter Valid Pancard Number');
                                setHandleKyc({
                                    ...handleKyc,
                                    pan_number: e.target.value,
                                    pancard: false,
                                })
                            } else {
                                setErrorPancard('');
                                if (regex.test(e.target.value)) {
                                    setHandleKyc({
                                        ...handleKyc,
                                        pan_number: e.target.value,
                                        pancard: true,
                                    })
                                }
                            }
                        }}
                        onKeyPress={(e) => handleDecimal(e, 'number')}
                    />
                    {PanStatus === 200 ? <small className='otpBtn'> <Check /></small> : handleKyc?.pancard ? <small className='pointer otpBtn' onClick={async () => {
                        dispatch(setPanLoader(true));
                        await dispatch(verifyPan({ pan_number: handleKyc?.pan_number }))

                    }}>{'Send'} </small> : <></>}
                </InputGroup>
                {/* {
                    handleKyc?.pancard && <small className='pointer' onClick={() => { SendOTP(handleKyc.aadhaar_number) }}> {panLoader ? 'Loading...' :'Send OTP'} </small>
                } */}
                {
                    errorPancard && <small className='text-danger text-center text-capitalize'> {errorPancard} </small>
                }
            </Col>

            {/* <Col sm={6} className="mb-1">
          <Label className="form-label" for="pan_image">
            Upload PAN Card
          </Label>
          <Controller
            id="pan_image"
            name="pan_image"
            control={control}
            // {...register('pan_image', {
            //     required: 'Please Upload PAN Card'
            //   })}
            render={({ field }) => (
              <Input
                id="pan_image"
                type="file"
                name="pan_image"
                invalid={errors.pan_image && true}
                onChange={handleFile}
                files={file}
              />
            )}
          />
        </Col> */}
            {/* {OTPInput?.panOtpInput && <>

                <Col md="6" xm="6" >
                    <label htmlFor="aadharOtp">OTP</label>
                    <InputGroup>
                      <input
                          placeholder="Enter otp"
                          id="aadharOtp"
                          name="aadharOtp"
                          className={`w-bolder text-black form-control`}
                          value={handleKyc?.aadharOtp}
                          onChange={(e) => {
                              const { value } = e.target;
                              handleInputChange(value, 'aadharOtp')
                          }}
                          onKeyPress={(e) => handleDecimal(e, 'number')}
                      />
                      {
                          handleKyc?.aadharOtpBtn && <small className='pointer otpBtn' onClick={() => {
                              dispatch(setAddharLoader(true))
                              dispatch(validateAdharOTP({
                                pan_number:handleKyc?.pan_number,
                                requestId:handleKyc?.requestId,
                                otp:handleKyc?.aadharOtp
                              }))

                          }}> Send</small>
                      }
                    </InputGroup>
                    {(message && isActive) ? <small>Resend OTP in 00:{seconds < 10 ? `0${seconds}` : seconds}</small> : <small className='pointer' onClick={reSend}> Resend OTP </small>}

                    
                </Col>
            </>
            } */}
            {
                console.log('first', AdharStatus === 200 && PanStatus === 200)
            }

            <Col md="12" xm="12" className='d-flex justify-content-center'>
                <Button
                    className="mt-1 me-1"
                    color="primary"
                    onClick={() => submit()}
                    disabled={AdharStatus === 200 && PanStatus === 200 ? false : true}
                >
                    {loader ? (
                        <Spinner text="Loading..." color="white" size="sm" />
                    ) : (
                        'Submit'
                    )}
                </Button>
                <Button
                    className="mt-1"
                    color="danger"
                    outline
                    onClick={() => handleDiscard()}
                >
                    Discard
                </Button>
            </Col>
        </Row>
    )
}
export default KYCDeatils